import React from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, isDark}) {
  const highlights = [cardInfo.desc]
    .concat(Array.isArray(cardInfo.descBullets) ? cardInfo.descBullets : [])
    .filter(Boolean);

  return (
    <div className={isDark ? "experience-card-dark" : "experience-card"}>
      <div className="experience-banner">
        <h5 className="experience-text-company">{cardInfo.company}</h5>
      </div>
      <div className="experience-text-details">
        <h5
          className={
            isDark
              ? "experience-text-role dark-mode-text"
              : "experience-text-role"
          }
        >
          {cardInfo.role}
        </h5>
        <p
          className={
            isDark
              ? "experience-text-date dark-mode-text"
              : "experience-text-date"
          }
        >
          {cardInfo.date}
        </p>
        {highlights.length > 0 ? (
          <ul className="experience-highlights">
            {highlights.map((item, i) => (
              <li
                key={`${cardInfo.company}-${i}`}
                className={isDark ? "experience-highlight dark-mode-text" : "experience-highlight"}
              >
                {item}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
